'use strict';

const pluginId = "scaffolder";

exports.pluginId = pluginId;
//# sourceMappingURL=pluginId.cjs.js.map
